import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { CaptionProps, useNavigation } from 'react-day-picker';

const CustomCaption = ({ displayMonth }: CaptionProps) => {
  const { goToMonth, nextMonth, previousMonth } = useNavigation();

  const goToPreviousMonth = () => previousMonth && goToMonth(previousMonth);
  const goToNextMonth = () => nextMonth && goToMonth(nextMonth);

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const years = Array.from({ length: 100 }, (_, i) => currentYear - i);

  const isCurrentYear = displayMonth.getFullYear() === currentYear;
  const isDecember = displayMonth.getMonth() === 11;
  const disableNext = isCurrentYear && isDecember;

  const handleYearChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newYear = Number(e.target.value);
    const newDate = new Date(displayMonth);
    newDate.setFullYear(newYear);
    goToMonth(newDate);
  };

  return (
    <div className="flex items-center justify-center gap-2 relative w-full">
      <button
        type="button"
        onClick={goToPreviousMonth}
        className="absolute left-1 p-1 hover:bg-accent rounded"
      >
        <ChevronLeft className="h-4 w-4" />
      </button>

      <div className="flex items-center gap-2">
        <span className="text-sm font-medium">
          {displayMonth.toLocaleString('default', { month: 'long' })}
        </span>
        <select
          value={displayMonth.getFullYear()}
          onChange={handleYearChange}
          className="border rounded-md p-1 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
        >
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>

      <button
        type="button"
        onClick={goToNextMonth}
        disabled={disableNext}
        className={`absolute right-1 p-1 rounded ${
          disableNext ? 'cursor-not-allowed opacity-50' : 'hover:bg-accent'
        }`}
      >
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  );
};

export default CustomCaption;
